"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiBadge = getMuiBadge;
function getMuiBadge(palette) {
  return {
    defaultProps: {
      // @ts-ignore missing in defaultProps type
      'data-testid': 'required'
    },
    styleOverrides: {
      root: {
        '.MuiBadge-badge': {
          '&.MuiBadge-badgeCount': {
            '&.MuiBadge-colorError': {
              backgroundColor: palette.error.main
            },
            '&.MuiBadge-colorSuccess': {
              backgroundColor: palette.success.main
            }
          },
          backgroundColor: palette.primary.main,
          borderRadius: '8px',
          color: palette.common.white,
          fontSize: '10px',
          fontWeight: 600,
          height: '16px',
          lineHeight: '14px',
          minWidth: '20px',
          padding: '2px 4px',
          width: 'fit-content'
        },
        '.MuiSvgIcon-root': {
          color: palette.grey.A700,
          fontSize: '24px'
        }
      }
    }
  };
}